import { Separator, toolkitCx } from "@sundae/ui-toolkit";
import { FC } from "react";
import FadeInBasic from "../../FadeInView/FadeInBasic";
import TasteTestContributionWarning from "../TasteTestContributionWarning";
import TasteTestDepositOutput from "../TasteTestDepositOutput";
import TasteTestTransactionDetails from "../TasteTestDepositTransactionDetails";

const TasteTestDepositOrderPreview: FC = () => {
  return (
    <FadeInBasic className="flex flex-col gap-6" transitionDelay={0}>
      <TasteTestDepositOutput />
      <Separator orientation="horizontal" className={toolkitCx.layout.background.separator} />
      <TasteTestTransactionDetails />
      <TasteTestContributionWarning withConsent />
    </FadeInBasic>
  );
};

export default TasteTestDepositOrderPreview;
